import { Injectable } from '@angular/core';
import { UrlService } from 'src/app/shared/services/url/url.service';
import { environment } from 'src/environments/environment';
import { AppConfigService } from 'src/app/core/config/config.service';
import { CategoriesUri, OrderUri, ReportstUri, CustomerUri } from 'src/app/core/config/config.model';

@Injectable({ providedIn: 'root' })

export class EgiftCardsUriService {
  private baseUrl: string;
  private baseUrlTwo: string;
  private categoriesUri: CategoriesUri;
  private orderUri: OrderUri;
  private reportsUri: ReportstUri;
  private customerUri: CustomerUri;

  constructor
    (private urlService: UrlService, private apiConfig: AppConfigService) {

    this.baseUrl = environment.baseUrl;
    this.baseUrlTwo = environment.baseUrlTwo;
    this.categoriesUri = apiConfig.appConfig.categoriesUri;
    this.orderUri = apiConfig.appConfig.orderUri;
    this.reportsUri = apiConfig.appConfig.reportsUri;
    this.customerUri = apiConfig.appConfig.customerUri;
  }

  getCategoriesUri() {
    return this.urlService.combineUri(this.baseUrlTwo, this.categoriesUri.cards, this.categoriesUri.categories);
  }

  getProductListUri() {
    return this.urlService.combineUri(this.baseUrl, 'cards', 'products')
  }

  getProductListByAdmin() {
    return this.urlService.combineUri(this.baseUrlTwo, 'cards', 'products-by-admin')
  }

  getOrdersUri() {
    return this.urlService.combineUri(this.baseUrl, this.orderUri.digitalCard, this.orderUri.orders)
  }
  
  getOrdersArchiveUri() {
    return this.urlService.combineUri(this.baseUrl, this.orderUri.digitalCard, this.orderUri.orders_archive)
  }

  getOrdersByAdminUri() {
    return this.urlService.combineUri(this.baseUrl, this.reportsUri.reports, this.reportsUri.panel, this.reportsUri.orderReports);
  }

  getResendOrdersUri(orderId: number) {
    return this.urlService.combineUri(this.baseUrl, this.orderUri.digitalCard, this.orderUri.orders, orderId, this.orderUri.resend);
  }

  getReportUri() {
    return this.urlService.combineUri(this.baseUrl, this.reportsUri.reports, this.reportsUri.panel, this.reportsUri.digital_product_finance);
  }

  getUserReportUri() {
    return this.urlService.combineUri(this.baseUrl, this.reportsUri.reports, this.reportsUri.panel, this.reportsUri.digital_user_finance);
  }

  getUserDetailUri(userId: number) {
    return this.urlService.combineUri(this.baseUrl, this.customerUri.customers, this.customerUri.my_customers, userId);
  }

  getProductDetailUri(productId: number) {
    return this.urlService.combineUri(this.baseUrl, this.categoriesUri.cards, this.categoriesUri.products, productId);
  }

  getFavoriteSuggestionUri(productId: number) {
    return this.urlService.combineUri(this.baseUrl, this.categoriesUri.cards, this.categoriesUri.suggestions, productId, this.categoriesUri.favorite)
  }

  getFavoriteProductUri(productId: number) {
    return this.urlService.combineUri(this.baseUrl, this.categoriesUri.cards, this.categoriesUri.products, productId, this.categoriesUri.favorite)
  }

  getFavoriteProductsUri() {
    return this.urlService.combineUri(this.baseUrl, this.categoriesUri.cards, this.categoriesUri.products, this.categoriesUri.favorites)
  }

  getFavoriteSuggestionsUri(){
    return this.urlService.combineUri(this.baseUrl, this.categoriesUri.cards, this.categoriesUri.suggestions, this.categoriesUri.favorites)

  }

  getCardSubjectsUri() {
    return this.urlService.combineUri(this.baseUrlTwo, this.categoriesUri.cards, this.categoriesUri.subjects);
  }

  getProductDetailByRegionUri(id: number) {
    return this.urlService.combineUri(this.baseUrlTwo, this.categoriesUri.cards, this.categoriesUri.products_by_region, id);
  }

  downloadOrderExcelUri(id) {
    return this.urlService.combineUri(this.baseUrl, this.orderUri.digitalCard, this.orderUri.orders, id, this.orderUri.download)
  }

  downloadOrderReportExcelFile() {
    return this.urlService.combineUri(this.baseUrl, this.orderUri.digitalCard, this.orderUri.orders, this.orderUri.export_orders)
  }

  searchByProductTitleUri() {
    return this.urlService.combineUri(this.baseUrlTwo, this.categoriesUri.cards, this.categoriesUri.search_by_product_title);
  }

  getPriceListProductsUri(priceListId: number) {
    return this.urlService.combineUri(this.baseUrl, this.reportsUri.reports, this.reportsUri.panel, this.reportsUri.price_list_products, priceListId);
  }
}
